export default {
  init() {
    this.$element = document.querySelector('.js-tabs');
    this.$navigation = this.$element.querySelector('.tabs__nav');
    this.$navigationLinks = this.$navigation.querySelectorAll('a');
    this.$tabs = this.$element.querySelectorAll('.tabs__tab');

    this.$element.classList.add('is-init');

    this.hideTabs();
    this.createTabMenu();
    this.$navigation.addEventListener('click', this.handeMenuClick.bind(this));
    this.$navigation.addEventListener('keydown', this.handleMenuKey.bind(this));
  },

  /*
   * For each individual tab set class and aria-hidden attribute, and hide it
   */
  hideTabs() {
    // First tab visible
    this.$tabs[0].setAttribute('aria-hidden', 'false');

    // Hide te others
    this.$tabs.forEach(($tab, index) => {
      if (index !== 0) {
        $tab.classList.add('u-hide');
        $tab.setAttribute('aria-hidden', 'true');
      }
    });
  },

  createTabMenu() {
    this.$navigationLinks.forEach(($link, index) => {
      // Create an ID
      const id = 'tab-' + $link.getAttribute('href').slice(1);

      $link.setAttribute('id', id);
      $link.parentElement.setAttribute('aria-selected', 'false');
      // Set the list item to presentation
      $link.parentElement.setAttribute('role', 'presentation');
      // Assign aria attribute to the relevant tab panel
      this.$tabs[index].setAttribute('aria-labelledby', id);

      // Make first link selected
      if (index === 0) {
        $link.classList.add('is-active');
        $link.parentElement.setAttribute('aria-selected', 'true');
        $link.setAttribute('tabindex', '0');
      }
    });
  },

  handeMenuClick(event) {
    if (!event.target.matches('a')) return;
    const $link = event.target;
    // Remove previous active link
    this.$navigationLinks.forEach(el => {
      el.setAttribute('aria-selected', 'false');
      el.classList.remove('is-active');
    });
    // Set current link active
    $link.setAttribute('aria-selected', 'true');
    $link.classList.add('is-active');

    // Hide previously selected tab panel
    this.$tabs.forEach(el => {
      el.setAttribute('aria-hidden', 'true');
      el.classList.add('u-hide');
    });
    // Show current selected tab panel
    const tabLinkList = Array.prototype.slice.call( $link.parentElement.parentElement.children );
    const index = tabLinkList.indexOf($link.parentElement); // the parent of the link is the <li>
    const $newTab = this.$tabs[index];
    $newTab.setAttribute('aria-hidden', 'false');
    $newTab.classList.remove('u-hide');
    // Set focus to the first heading in the newly revealed tab content
    $newTab.children[0].setAttribute('tabindex', -1)
    $newTab.children[0].focus();

    event.preventDefault();
  },

  handleMenuKey(event) {
    if (!event.target.matches('a')) return;
    var $link = this.$navigationLinks.find( link => link.classList.contains('.is-active') );
    switch (event.which) {
      case 37:
      case 38:
        if ($link.parentElement.previousElementSibling.length != 0) {
          $link.parentElement.previousElementSibling.querySelector('> a').click();
        } else {
          this.$navigationLinks[this.$navigationLinks - 1].click();
        }
        break;
      case 39:
      case 40:
        if ($link.parentElement.nextElementSibling.length != 0) {
          $link.parentElement.nextElementSibling.querySelector('> a').click();
        } else {
          this.$navigationLinks[0].click();
        }
        break;
    }
  },
}
